module.exports = __webpack_public_path__ + "static/img/right-bottom-row-5.7842e020.webp";